<template>
<div>
	<confirm ref="confirm" id="confirmDeletePlan" @confirm="confirmDel"></confirm>
	<div v-show="!addShow" >
		<div class="addBtn">
			<button class="functionBtn save-btn sizeM mr2x" type="button" @click="showAdd('add')">{{$t('cmd10',['添加'])}}</button>
		</div>
		<div class="tableScope table table-4x mt1x bgContent" fillHeight="lastHeight,-.tableBatch">
				<loading ref="loading"></loading>
				<div class="tableSys head noSelect b cField bdLight-bottom" v-show="planList.length!=null && pagination.total>0">
					<div :class="{cMain:orderProperty=='year'}" class="sequence" :title="getLanguageStr('plant436','年份')" @click="onOrder('year')">
									<span>{{getLanguageStr('plant436','年份')}}</span>
									<span :sequence="orderProperty=='year'? orderDirection:''"></span>
								</div>
							<div :class="{cMain:orderProperty=='yearPlanTotal'}" class="sequence" :title="getLanguageStr('plant437','年计划发电量')" @click="onOrder('yearPlanTotal')">
									<span>{{getLanguageStr('plant437','年计划发电量')}}(kWh)</span>
									<span :sequence="orderProperty=='yearPlanTotal'? orderDirection:''"></span>
								</div>
					<div class="w20pct">{{getLanguageStr('word47','操作')}}</div>
				</div>
				<div class="posR" fillHeight="lastHeight,-.tableBatch" scroll>
					<div v-show="planList.length!=null && pagination.total>0" >
						<div class="tra-fast">
							<table>
								<thead class="head-token">
									<tr>
										<th></th>
										<th></th>
										<th class="w20pct"></th>
									</tr>
								</thead>
								<tbody class="bdLight-bottom_E emptyToken_EE textCut_EE">
									<tr v-for="(item,index) in planList" :key="index">
										<td :title="item.year">{{item.year}}</td>
										<td :title="item.yearPlanTotal">{{item.yearPlanTotal}}</td>
										<td class="cSub fSub w3x_E mr05x_E hover-c-main_E tra-fast_E vaM_E">
											<button class="hover-f-main" type="button" @click="showAdd('edit',item.id,item.year)" :title="$t('cmd8',['编辑'])">
									<Icon name="ico-edit-o" class="ico w1x h1x" />
								</button>
								<button class="hover-c-error hover-f-error " type="button" @click="deletePlan(item)" :title="$t('cmd9',['删除'])" >
									<Icon name="ico-recycle" class="ico w1x h1x"/>
								</button>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div> 
					<no-result v-show="!planList.length" class=""></no-result>
				</div>
				<div class="tableBatch bgContent cSub" :class="{disable:!planList.length}">
					<Pagination :pagination="pagination" :getList="getList" ref="Pagination"></Pagination>
				</div>
			</div>
		</div>
	<div v-show="addShow" >
		<ul class="w60pct" style="margin-left:auto;margin-right:auto">
			<li class="pt1x pb05x">
				<div class="w6x dpIB">{{getLanguageStr('plant_detail379','日期')}}:</div>
		 		<vue-datepicker-local v-model="serTime" ref="serDate" class="datepicker dpIB w18x" :format="'YYYY'"  @input="searchKey" :disabled="curType==='edit'" :disabled-date="disabledDate"></vue-datepicker-local>
			</li>
			<li class="pt05x pb05x" v-for="(item,index) in irradiances" :key="index">
				<div class="dpIB w6x">{{index+1}}{{getLanguageStr('device_management71','月')}}(kWh):</div>
				<input-text class="dpIB w18x input mr1x"
				 v-model="irradiances[index]" 
				:only="'absNumber'" 
				:ref="`month${index}`" 
				:matchType="'floor2x'" 
				:verification="'notEmpty,~:0.01~99999999.99'" 
				:placeholder="getLanguageStr('plant403','输入范围:0.01~99999999.99')"></input-text>
			</li>
		</ul>
		<div class="taC">
			<button class="bdSub boxR hover-bg-highLight fs12x w6x sizeM mt1x mr2x" type="button" @click="cancel">{{$t('cmd85',['取消'])}}</button>
			<button class="functionBtn w6x sizeM fs12x tra-fast mt1x mb2x" type="button" @click="save">{{$t('cmd84',['保存'])}}</button>
		</div>
	</div>
</div>
</template>
<script>
import { mapGetters,mapMutations,mapActions } from 'vuex'
import InputText from "@/components/common/ui/InputText"
import Loading from '@/components/common/ui/Loading'
import Pagination from '@/components/common/ui/Pagination.vue'
import * as lib from "@/util/lib.js";
import {timeFormat} from "@/util/lib.js";
import {getLanguageStr} from "@/util/language"
import Confirm from '@/components/common/ui/Confirm'
import NoResult from '@/components/common/ui/NoResult'
import {getGeneratePlanById,addGeneratePlan,getGeneratePlanList,deleteGeneratePlan} from '@/api/maintain/config/index.js'
export default {
	name: 'stationPlanConfig',
	props: {
		 basicInfo:{
			type:Object,
			default: () => ({})
			},
		  systemId:{
			type:Number,
			default:null
   		 },
	},
	components:{
		InputText,
		Loading,
		Pagination,
		Confirm,
		NoResult
	},
	data(){
		return{
			time:Number(lib.timeFormat(new Date(),"inc","%Y")),
			addShow:false,
			pagination: {}, // 分页数据
			"orderDirection": this.orderDirection||"DESC",
			"orderProperty":this.orderProperty||"year",
	    	orderByed: this.orderBy,
			serTime:this.getStationDay(),
			theoryPR:80,
			yearlyAttenuation:0.75,
			totalVal:0,
			irradiances:new Array(12),
			planList:[],
			curType:'add',
			toEdit:{
				year:null,
				janPlan:null,
				febPlan:null,
				marPlan:null,
				aprPlan:null,
				mayPlan:null,
				junPlan:null,
				julPlan:null,
				augPlan:null,
				septPlan:null,
				octPlan:null,
				novPlan:null,
				decPlan:null,
				stationId:null,
				systemId:null
			}
		}
	},
	methods:{
		getLanguageStr,
		floatFix:lib.floatFix,
		disabledDate(time){
			let bYear=this.time-20;
			let FYear=this.time+20;
			if(time.getFullYear()<bYear||time.getFullYear()>FYear) return true;
        },
		showList(){
			this.addShow=false
		},
		cancel(){
			this.addShow=false
			this.$emit('setLeave',1)
			this.reset();
		},
		deletePlan(item){
			this.$refs.confirm.show({
		        text:getLanguageStr('plant438','确认要删除该计划发电量吗？'),
		        obj:item
			})
		},
		confirmDel(obj){
			deleteGeneratePlan(this.basicInfo.id,obj.obj.id).then(res => {
				this.getList()
				this.$emit('refresh')
			}).catch(error => {
	        !_.isEmpty(error) && this.$notify(error)
	      })
		},
		getByYear(id,year){
			this.$refs.loading.show();
			let params={
					systemId:this.systemId,
					year:this.serTime
				}
			if(id&&year){
				params={...params,...{id:id,year:year}}
			}
			getGeneratePlanById(this.basicInfo.id,params).then(res => {
					this.toEdit={...res};
					if(this.toEdit.year!=null){
						this.serTime=String(this.toEdit.year)
						this.irradiances=[];
						this.irradiances.push(this.toEdit.janPlan,this.toEdit.febPlan,this.toEdit.marPlan,this.toEdit.aprPlan,this.toEdit.mayPlan,this.toEdit.junPlan,this.toEdit.julPlan,this.toEdit.augPlan,this.toEdit.septPlan,this.toEdit.octPlan,this.toEdit.novPlan,this.toEdit.decPlan)
					}else{
						this.irradiances=new Array(12);
					}
					this.$nextTick(function () {
						lib.fillHeight(this.irradiances)
						this.$refs.loading.hide();
					})
				}, error => {
					!_.isEmpty(error) && this.$notify(error)
					this.$refs.loading.hide();
				});
		},
	  	showAdd(type,id,year){
			  this.curType=type
			if(type=='edit'){
				this.$emit('showLast',4,{name:getLanguageStr('cmd8','编辑'),key:'edit'})	
				this.getByYear(id,year);
			}else{
				this.$emit('showLast',4,{name:getLanguageStr('cmd10','添加'),key:'add'})	
				this.getByYear();
			}
			this.addShow=true;
		},
		onOrder:function(name){//排序动作
			if(this.orderProperty==name){
				if(this.orderDirection=="DESC") this.orderDirection="ASC";
				else this.orderDirection="DESC";
			}
			else{
				this.orderProperty=name;
				// this.orderDirection="ASC";
			}
			this.getList();
		},
		getList(data){
			this.$refs.loading.show();
			if (data) this.$set(this.pagination.request, 'page', 1)
			let params={
				'order.direction':this.orderDirection,
				'order.property':this.orderProperty,
				'size':this.pagination.request.size,
				'page':this.pagination.request.page
			}
		   getGeneratePlanList(this.basicInfo.id,params).then(res => {
		    	this.planList=res.data;
	       		let {total} = res
				this.pagination = {...this.pagination, ...{total}}
		    	this.$nextTick(function () {
		          	lib.fillHeight()
					this.$refs.loading.hide();
				})
		     }, error => {
		        !_.isEmpty(error) && this.$notify(error)
		        this.$refs.loading.hide();
			});
		},
		getStationDay(){
			let day1=String(new Date(timeFormat(new Date(),"utc","%Y",{offset: this.basicInfo.region.timezone})).getFullYear())
			return day1
		},
		searchKey () {
			if(this.serTime!=""){
				this.serTime=String(this.serTime.getFullYear());
			}
			this.getByYear()
    	},
		reset:function(){
			$.each(this.$refs,function(){//遍历范围内所有需要reset对象,以清除一些报错内容
				if(this[0]&&this[0].reset) this[0].reset();
			});
		},
		_getPlan(id){
			this.getList();
		},
		save(){
			let allClear=true;
			$.each(this.$refs,function(){
				if(this[0]&&this[0].verification){//有时候某些组件隐藏掉会导致this为undefined
					let clear=this[0].doVerification();
					if(allClear) allClear=clear;
				}
			});
			if(allClear){
				let irradiances=_.cloneDeep(this.irradiances)
				let req={
					year:this.serTime,
					janPlan:irradiances[0],
					febPlan:irradiances[1],
					marPlan:irradiances[2],
					aprPlan:irradiances[3],
					mayPlan:irradiances[4],
					junPlan:irradiances[5],
					julPlan:irradiances[6],
					augPlan:irradiances[7],
					septPlan:irradiances[8],
					octPlan:irradiances[9],
					novPlan:irradiances[10],
					decPlan:irradiances[11],
					id:this.toEdit.id,
					stationId:this.basicInfo.id,
					systemId:this.systemId
				}
				addGeneratePlan(this.basicInfo.id,req).then(response=>{
					this.addShow=false;
					this.getList()
					this.$emit('setLeave',1)
					this.$emit('refresh')
				},error=>{
					!_.isEmpty(error) && this.$notify(error)
				})
			}
		},
	},
	mounted(){
		this.$nextTick(()=>{
			lib.fillHeight();
			lib.setScroll($(this.$el).find('.tableScope [scroll]'));
		});
	}
}
</script>
<style lang="scss" scoped>
.datepicker{
	height:2.5em;
	line-height: 2.5em;
	padding-left: 0;
	width: 18em;
}
.offset-list {
	width:100%;border-top:1px solid rgba(0, 0, 0, 0.1);
	li{
		border-bottom:1px solid rgba(0, 0, 0, 0.1);
		overflow: hidden;
		height: 3em;
		line-height: 3em;
		>div {
			width: 33.33%;
			float: left;
			padding-left: 2em;
		}
	}
}
.addBtn{
	margin-top: 1em;
	text-align: right;
	margin-bottom: 1em;
}
</style>



// WEBPACK FOOTER //
// src/view/maintain/light/plant/part/StationPlanConfig.vue